;(function () {
  angular
    .module('contrast.tsv.onboard')
    .controller('TsvModalWizardCtrl', tsvModalWizardCtrl)

  function tsvModalWizardCtrl(
    $scope,
    $uibModalInstance,
    $location,
    $timeout,
    FileSaver,
    Blob,
    permissions,
    tsvApiConfig,
    UserService,
    ProfileService,
    ErrorService,
    logoutService,
    isTsvMandatory,
    TSV_DEVICE_TYPES,
    TSV_TYPES
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        step: 0,
        email: ProfileService.getEmail(),
        is_type_undefined: true,
        authorized: true,
        device_types: TSV_DEVICE_TYPES,
        backupdownloaded: false
      }
    })

    angular.extend($scope, {
      back: back,
      next: next,
      cancel: cancel,
      finish: finish
    })

    function back() {
      if ($scope.model.step == 0) {
        $uibModalInstance.dismiss('cancel')
      } else if ($scope.model.step == 1 || $scope.model.step == 2) {
        $scope.model.step--
      }
    }

    function cancel() {
      if (!isTsvMandatory) {
        $location.path(UserService.buildUrl('/dashboard'), true)
        $uibModalInstance.dismiss('cancel')
      } else {
        logoutService.logout({ redirectToSignin: true })
      }
    }

    function finish() {
      $location.path(UserService.buildUrl('/dashboard'), true)
      $uibModalInstance.dismiss('cancel')
    }

    function next() {
      if ($scope.model.tsv.type && $scope.model.step == 0) {
        if ($scope.model.tsv.type == 'GOOGLE') {
          getAuthenticator()
        }
        $scope.model.step = 1
      } else if ($scope.model.step == 1) {
        if ($scope.model.tsv.type == 'EMAIL') {
          getAuthenticator()
        }
        $scope.model.step = 2
        $scope.model.code = undefined
        $scope.model.authorized = true
      } else if ($scope.model.code && $scope.model.step == 2) {
        authorizeTsvCode($scope.model.tsv.type, $scope.model.code)
      } else if ($scope.model.step == 3 && !$scope.model.backupdownloaded) {
        downloadBackupCodes()
      } else if ($scope.model.step == 3 && $scope.model.backupdownloaded) {
        confirmBackup()
      }
    }

    function getAuthenticator() {
      if ($scope.model.tsv.type == TSV_TYPES.GOOGLE) {
        return getTsvGoogleCredentials()
      } else if ($scope.model.tsv.type == TSV_TYPES.EMAIL) {
        return sendTsvEmailCredentials()
      }
    }

    function getTsvGoogleCredentials() {
      return tsvApiConfig
        .getTsvGoogleCredentials()
        .then(function (response) {
          $scope.model.qr = response.data.qr
          $scope.model.token = response.data.key
        })
        .catch(ErrorService.processError)
    }

    function sendTsvEmailCredentials() {
      return tsvApiConfig
        .sendTsvEmailCredentials()
        .catch(ErrorService.processError)
    }

    function authorizeTsvCode(type, code) {
      var data = { code: code }

      if (type == TSV_TYPES.GOOGLE) {
        return tsvApiConfig
          .authorizeGoogleTsvCode(data)
          .then(function (response) {
            updateTsvType(0)
            _handleAuthorizeSuccess(response)
          })
          .catch(ErrorService.processError)
      } else if (type == TSV_TYPES.EMAIL) {
        return tsvApiConfig
          .authorizeEmailTsvCode(data)
          .then(function (response) {
            updateTsvType(1)
            _handleAuthorizeSuccess(response)
          })
          .catch(ErrorService.processError)
      }
    }

    function _handleAuthorizeSuccess(response) {
      $scope.model.step = 3
      $scope.model.codes = response.data.scratch_codes
      $scope.model.authorized = true
    }

    function updateTsvType(type) {
      return tsvApiConfig
        .updateTsvType({ type: type })
        .catch(ErrorService.processError)
    }

    function downloadBackupCodes() {
      $scope.model.backupdownloading = true

      var codesTxt = ''
      angular.forEach($scope.model.codes, function (code) {
        codesTxt = codesTxt + code + '\r\n'
      })

      var data = new Blob([codesTxt], { type: 'text/plain;charset=utf-8' })
      var date = new Date().toISOString().slice(0, 10).replace(/-/g, '')
      FileSaver.saveAs(data, date + '-backup-codes.txt', true)

      $timeout(function () {
        $scope.model.backupdownloading = false
        $scope.model.backupdownloaded = true
      }, 500)
    }

    function confirmBackup() {
      var form = { type: $scope.model.tsv.type, enabled: true }
      if ($scope.model.tsv.device) {
        form.device = $scope.model.tsv.device.toUpperCase()
      }
      update(form)
      $scope.model.step = 4
    }

    function update(form) {
      return permissions.getDefaultOrganization().then(function () {
        return tsvApiConfig.updateUserTsv(form).catch(ErrorService.processError)
      })
    }
  }
})()
